export default "__VITE_ASSET__Dx0_U8IV__"